import { render, staticRenderFns } from "./PlaceAnOrder.vue?vue&type=template&id=b666d608&scoped=true&"
import script from "./PlaceAnOrder.vue?vue&type=script&lang=js&"
export * from "./PlaceAnOrder.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAnOrder.vue?vue&type=style&index=0&id=b666d608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b666d608",
  null
  
)

export default component.exports